import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useBusinessContext } from "@/hooks/useBusinessContext";
import { useUpdateBusinessContext } from "@/features/onboarding/hooks/useUpdateBusinessContext";
import { useSupabaseClient } from "@/lib/supabase";

export function DisplayNameModal() {
  const { isReady } = useSupabaseClient();
  const { query } = useBusinessContext();
  const { mutate, isPending } = useUpdateBusinessContext();
  const [name, setName] = useState("");
  const [dismissed, setDismissed] = useState(false);

  // Profile loaded and display_name is missing → show modal
  const profileLoaded = isReady && !query.isLoading && query.data !== undefined;
  const needsName = profileLoaded && !query.data?.display_name?.trim();
  const open = needsName && !dismissed;

  async function handleSave() {
    const trimmed = name.trim();
    if (!trimmed) return;
    await mutate({ display_name: trimmed });
    setDismissed(true);
  }

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-sm"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Como você se chama?</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Informe seu nome completo para personalizar sua experiência.
        </p>
        <div className="space-y-2 mt-2">
          <Label htmlFor="display-name">Nome completo</Label>
          <Input
            id="display-name"
            placeholder="Ex: Rafael de Oliveira"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !isPending && handleSave()}
            autoFocus
          />
          <p className="text-xs text-muted-foreground">
            Inclua sobrenome composto se for o caso (ex: da Silva, de Melo).
          </p>
        </div>
        <Button
          className="w-full mt-2"
          disabled={!name.trim() || isPending}
          onClick={handleSave}
        >
          {isPending ? "Salvando..." : "Continuar"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
